import { useMutation, useQueryClient } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { CreateCommunityStrategy } from 'services/apiServices';
import {
  TCreateStrategyResult,
  Errors,
  CreateStrategyParams,
} from 'types/ApiServicesTypes';

export default function useCreateCommunityStrategy() {
  const { showAlert } = useContext(ToastContext);
  const queryClient = useQueryClient();

  const mutation = useMutation<TCreateStrategyResult, Errors, CreateStrategyParams>(
    ['CreateCommunityStrategy'],
    values =>
      CreateCommunityStrategy(values)
        .then(res => {
          showAlert!('Strategy created successfully', 'success');
          // Invalidate and refetch strategies list
          void queryClient.invalidateQueries(['GetCommunityStrategies']);
          return res;
        })
        .catch(err => {
          showAlert!(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
} 